import React from 'react';
// import PropTypes from 'prop-types';
import {Switch, Grid} from '@material-ui/core';

class ChangeSwitch extends React.Component {
    state = {
        checked: false,
    };

    componentWillMount() {
        if (this.props.defaultValue) {
            this.setState({checked: this.props.defaultValue});
        }
    }

    handleChange = (event) => {
        this.setState({checked: event.target.checked});
        this.props.onChange(
            this.props.title,
            event.target.checked,
            this.props.changeSku,
        );
    };

    render() {
        const {scLabel, tfsLabel, testid} = this.props;
        return (
            <div className="change-switch">
                <Grid className="sc-label">{scLabel}</Grid>
                <Switch
                    classes={{
                        root: 'switch-root',
                        switchBase: 'switch-base',
                        checked: 'switch-checked',
                    }}
                    checked={this.state.checked}
                    onChange={this.handleChange}
                    value={this.state.checked}
                    inputProps={{
                        'aria-label': 'secondary checkbox',
                        'data-testid': testid
                            ? testid
                            : 'change-switch-sku-type',
                    }}
                />
                <Grid className="tfs-label">{tfsLabel}</Grid>
            </div>
        );
    }
}

ChangeSwitch.propTypes = {};
export default ChangeSwitch;
